export default __webpack_public_path__ + "b02a9ddc23605db5a936eb9a8a323c9c.svg";